export default {"src":"/_next/static/media/hot-news-red-icon.743ca4f3.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};